//this is only for jango
//bing
// var bing_song2 = function (w, d, t, r, u) {
//   var f, n, i;
//   (w[u] = w[u] || []),
//     (f = function () {
//       var o = {
//         ti: "4055953",
//       };
//       (o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad");
//     }),
//     (n = d.createElement(t)),
//     (n.src = r),
//     (n.async = 1),
//     (n.onload = n.onreadystatechange =
//       function () {
//         var s = this.readyState;
//         (s && s !== "loaded" && s !== "complete") ||
//           (f(), (n.onload = n.onreadystatechange = null));
//       }),
//     (i = d.getElementsByTagName(t)[0]),
//     i.parentNode.insertBefore(n, i);
// };

// var call_bing_song2 = function () {
//   console.log("bing song 2");

//   bing_song2(window, document, "script", "//bat.bing.com/bat.js", "uetq");
// };

export function bing_song3(w, d, t, r, u) {
  var f, n, i;
  (w[u] = w[u] || []),
    (f = function () {
      var o = {
        ti: "4055954",
      };
      (o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad");
    }),
    (n = d.createElement(t)),
    (n.src = r),
    (n.async = 1),
    (n.onload = n.onreadystatechange =
      function () {
        var s = this.readyState;
        (s && s !== "loaded" && s !== "complete") ||
          (f(), (n.onload = n.onreadystatechange = null));
      }),
    (i = d.getElementsByTagName(t)[0]),
    i.parentNode.insertBefore(n, i);
}

export function call_bing_song3() {
  console.log("bing song 3");
  bing_song3(window, document, "script", "//bat.bing.com/bat.js", "uetq");
}

//google -- only called and defined for jango.com
var goog_snippet_vars = function () {
  var w = window;
  w.google_conversion_id = 1060625277;
  w.google_remarketing_only = false;
};
var goog_snippet_vars_song2 = function () {
  window.google_conversion_label = "CvEZCKndzlwQ_bbf-QM";
};
var goog_snippet_vars_song3 = function () {
  window.google_conversion_label = "31rDCPWX518Q_bbf-QM";
};

import { loadScript } from "lib/ajax";

export function goog_report_conversion(song_number) {
  goog_snippet_vars();

  if (song_number == "song2") {
    goog_snippet_vars_song2();
  } else if (song_number == "song3") {
    goog_snippet_vars_song3();
  }

  window.google_conversion_format = "3";
  window.google_is_call = true;
  var opt = new Object();
  opt.onload_callback = function () {};
  loadScript("//www.googleadservices.com/pagead/conversion_async.js").then(
    () => {
      var conv_handler = window["google_trackConversion"];
      if (typeof conv_handler == "function") {
        console.log("google conversion: " + window.google_conversion_label);
        // console.log(opt);
        conv_handler(opt);
      }
    }
  );
}
